
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import "./header.css";
import logom from "../../assets/images/logom.png";
import {Link} from "react-router-dom"
function Header({ rootData }) {
  const [isScrolledTop, setIsScrolledTop] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
  }, []);
  const listenToScroll = () => {
    const position = window.pageYOffset;
    if (position >= 100) {
      setIsScrolledTop(true);
    }
    if (position < 100) {
      setIsScrolledTop(false);
    }
  };
  return (
    <div className="mobileHeader bg-color-2 text-center py-2 block lg:hidden sticky top-0 z-50">
      <Container>
        <Row className="items-center">
          <Col xs={3}>
            <div>
              <Link to={'/'}>
                <img src={logom} alt="mobile logo" className="w-12" />
              </Link>
            </div>
          </Col>
          {/* <Col xs={6}>
            <div>
              <p className="color-1 mb-0 text-lg manpro">
                {`${rootData.userData.profile_data?.fname} ${rootData.userData.profile_data?.lname}`}
              </p>
            </div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}
const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps, null)(Header);